import React, { useState,useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { API_URL, LOCATION_ID } from "..";
import { toast,ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Fake sample data to preview inside templates
const sampleData = {
  company: {
    name: "Company Name",
    address: "Company Address",
    vat: "Company VAT",
    email: "hello@email.com",
    accountTitle: "ACCOUNT TITLE",
    sortCode: "SORTCODE",
    accountNumber: "ACCOUNTNUMBER",
    phone: "COMPANYPHONE",
    logo: "https://placehold.co/100x50?text=Company Logo",
  },
  customer_name: "CUSTOMERNAME",
  phone: "CUSTOMERPHONE",
  address: "CUSTOMERADDRESS",
  invoice_number: "INV_",
  order_number: "ORD-101",
  issue_date: "INVOICEISSUEDATE",
  currency: "$",
  items: [
    { item_name: "Item 1", quantity: 1, unit_price: 500, price: 500, description: "Description of the item 1" },
    { item_name: "Item 2", quantity: 12, unit_price: 10, price: 120, description: "Description of the item 2" },
    { item_name: "Item 3", quantity: 1, unit_price: 200, price: 200, description: "Description of the item 3" },
  ],
  discount: 5,
  tax: 10,
};

// Utility functions
const calculateSubtotal = (items) =>
  items.reduce((sum, i) => sum + (i.price || 0), 0);
const calculateTax = (data) =>
  (calculateSubtotal(data.items) * (parseFloat(data.tax) || 0)) / 100;
const calculateTotal = (data) =>
  calculateSubtotal(data.items) -
  (calculateSubtotal(data.items) * (parseFloat(data.discount) || 0)) / 100 +
  calculateTax(data);
const convertDateFormat = (date) => new Date(date).toLocaleDateString();

// ========== Template 1: Classic Professional ========== //
const ClassicTemplate = ({ data }) => (
  <div style={{ fontSize: 11, border: "2px solid #2c3e50", padding: 20, backgroundColor: "#fff", fontFamily: "Arial, sans-serif" }}>
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20, borderBottom: "3px solid #2c3e50", paddingBottom: 15 }}>
      <img src={data.company.logo} alt="Logo" style={{ width: 80, height: 40 }} />
      <div style={{ textAlign: "right", fontSize: 9, color: "#2c3e50" }}>
        <div style={{ fontWeight: "bold", fontSize: 11 }}>{data.company.name}</div>
        <div>{data.company.address}</div>
        <div>VAT: {data.company.vat}</div>
        <div>{data.company.email}</div>
      </div>
    </div>
    <h6 style={{ textAlign: "center", color: "#2c3e50", backgroundColor: "#ecf0f1", padding: 10, margin: 0, marginBottom: 20 }}>INVOICE</h6>
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
      <div style={{ fontSize: 10 }}>
        <div style={{ fontWeight: "bold", marginBottom: 5 }}>Bill To:</div>
        <div>{data.customer_name}</div>
        <div>{data.address}</div>
        <div>{data.phone}</div>
      </div>
      <div style={{ textAlign: "right", fontSize: 10 }}>
        <div>Invoice #: <span style={{ fontWeight: "bold" }}>{data.invoice_number}</span></div>
        <div>Date: {convertDateFormat(data.issue_date)}</div>
        <div>Order #: {data.order_number}</div>
      </div>
    </div>
    <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 20 }}>
      <thead>
        <tr style={{ backgroundColor: "#2c3e50", color: "#fff" }}>
          <th style={{ padding: 8, textAlign: "left", border: "1px solid #2c3e50" }}>Description</th>
          <th style={{ padding: 8, border: "1px solid #2c3e50" }}>Qty</th>
          <th style={{ padding: 8, border: "1px solid #2c3e50" }}>Unit Price</th>
          <th style={{ padding: 8, border: "1px solid #2c3e50" }}>Total</th>
        </tr>
      </thead>
      <tbody>
        {data.items.map((i, idx) => (
          <tr key={idx} style={{ backgroundColor: idx % 2 ? "#f8f9fa" : "#fff" }}>
            <td style={{ padding: 8, border: "1px solid #ddd" }}>{i.item_name}</td>
            <td style={{ padding: 8, border: "1px solid #ddd", textAlign: "center" }}>{i.quantity}</td>
            <td style={{ padding: 8, border: "1px solid #ddd", textAlign: "right" }}>{data.currency}{i.unit_price}</td>
            <td style={{ padding: 8, border: "1px solid #ddd", textAlign: "right" }}>{data.currency}{i.price}</td>
          </tr>
        ))}
      </tbody>
    </table>
    <div style={{ textAlign: "right", fontSize: 10 }}>
      <div style={{ marginBottom: 5 }}>Subtotal: {data.currency}{calculateSubtotal(data.items)}</div>
      <div style={{ marginBottom: 5 }}>Discount ({data.discount}%): -{data.currency}{((calculateSubtotal(data.items) * data.discount) / 100).toFixed(2)}</div>
      <div style={{ marginBottom: 5 }}>Tax ({data.tax}%): {data.currency}{calculateTax(data).toFixed(2)}</div>
      <div style={{ fontWeight: "bold", fontSize: 12, backgroundColor: "#2c3e50", color: "#fff", padding: 5 }}>Total: {data.currency}{calculateTotal(data).toFixed(2)}</div>
    </div>
  </div>
);

// ========== Template 2: Modern Minimal ========== //
const ModernTemplate = ({ data }) => (
  <div style={{ fontSize: 11, padding: 20, backgroundColor: "#fff", fontFamily: "Helvetica, sans-serif", border: "1px solid #e0e0e0" }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 30 }}>
      <img src={data.company.logo} alt="Logo" style={{ width: 90, height: 45 }} />
      <h6 style={{ fontSize: 24, color: "#333", fontWeight: 300, margin: 0 }}>INVOICE</h6>
    </div>
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 30 }}>
      <div style={{ fontSize: 10, lineHeight: 1.5 }}>
        <div style={{ fontWeight: "600", fontSize: 11, color: "#666" }}>FROM</div>
        <div style={{ color: "#333" }}>{data.company.name}</div>
        <div style={{ color: "#666" }}>{data.company.address}</div>
        <div style={{ color: "#666" }}>{data.company.email}</div>
      </div>
      <div style={{ fontSize: 10, textAlign: "right", lineHeight: 1.5 }}>
        <div style={{ fontWeight: "600", fontSize: 11, color: "#666" }}>TO</div>
        <div style={{ color: "#333" }}>{data.customer_name}</div>
        <div style={{ color: "#666" }}>{data.address}</div>
        <div style={{ color: "#666" }}>{data.phone}</div>
      </div>
    </div>
    <div style={{ backgroundColor: "#f8f9fa", padding: 15, marginBottom: 20, borderLeft: "4px solid #007bff" }}>
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10 }}>
        <div>Invoice #: <span style={{ fontWeight: "600" }}>{data.invoice_number}</span></div>
        <div>Date: {convertDateFormat(data.issue_date)}</div>
      </div>
    </div>
    <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 30 }}>
      <thead>
        <tr>
          <th style={{ padding: 12, textAlign: "left", borderBottom: "2px solid #007bff", fontSize: 10, fontWeight: "600" }}>Item</th>
          <th style={{ padding: 12, textAlign: "center", borderBottom: "2px solid #007bff", fontSize: 10, fontWeight: "600" }}>Qty</th>
          <th style={{ padding: 12, textAlign: "right", borderBottom: "2px solid #007bff", fontSize: 10, fontWeight: "600" }}>Rate</th>
          <th style={{ padding: 12, textAlign: "right", borderBottom: "2px solid #007bff", fontSize: 10, fontWeight: "600" }}>Amount</th>
        </tr>
      </thead>
      <tbody>
        {data.items.map((i, idx) => (
          <tr key={idx}>
            <td style={{ padding: 10, borderBottom: "1px solid #eee" }}>{i.item_name}</td>
            <td style={{ padding: 10, textAlign: "center", borderBottom: "1px solid #eee" }}>{i.quantity}</td>
            <td style={{ padding: 10, textAlign: "right", borderBottom: "1px solid #eee" }}>{data.currency}{i.unit_price}</td>
            <td style={{ padding: 10, textAlign: "right", borderBottom: "1px solid #eee" }}>{data.currency}{i.price}</td>
          </tr>
        ))}
      </tbody>
    </table>
    <div style={{ textAlign: "right", fontSize: 10 }}>
      <div style={{ marginBottom: 8, color: "#666" }}>Subtotal: {data.currency}{calculateSubtotal(data.items)}</div>
      <div style={{ marginBottom: 8, color: "#666" }}>Tax: {data.currency}{calculateTax(data).toFixed(2)}</div>
      <div style={{ fontSize: 14, fontWeight: "600", color: "#007bff" }}>Total: {data.currency}{calculateTotal(data).toFixed(2)}</div>
    </div>
  </div>
);

// ========== Template 3: Creative Colorful ========== //
const CreativeTemplate = ({ data }) => (
  <div style={{ fontSize: 11, padding: 20, backgroundColor: "#fff", fontFamily: "Arial, sans-serif", position: "relative" }}>
    <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: 6, background: "linear-gradient(90deg, #ff6b6b, #4ecdc4, #45b7d1)" }}></div>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 25, marginTop: 15 }}>
      <div>
        <img src={data.company.logo} alt="Logo" style={{ width: 85, height: 42 }} />
        <h6 style={{ fontSize: 20, color: "#ff6b6b", margin: "10px 0 0 0", fontWeight: "bold" }}>INVOICE</h6>
      </div>
      <div style={{ textAlign: "right", fontSize: 9, color: "#555" }}>
        <div style={{ fontWeight: "bold", color: "#333" }}>{data.company.name}</div>
        <div>{data.company.address}</div>
        <div>{data.company.email}</div>
      </div>
    </div>
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 25 }}>
      <div style={{ backgroundColor: "#ff6b6b", color: "#fff", padding: 12, borderRadius: 8, fontSize: 10 }}>
        <div style={{ fontWeight: "bold", marginBottom: 8 }}>BILL TO:</div>
        <div>{data.customer_name}</div>
        <div>{data.address}</div>
      </div>
      <div style={{ backgroundColor: "#4ecdc4", color: "#fff", padding: 12, borderRadius: 8, fontSize: 10, textAlign: "right" }}>
        <div>Invoice: {data.invoice_number}</div>
        <div>Date: {convertDateFormat(data.issue_date)}</div>
      </div>
    </div>
    <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 20, borderRadius: 8, overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
      <thead>
        <tr style={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", color: "#fff" }}>
          <th style={{ padding: 10, textAlign: "left" }}>Description</th>
          <th style={{ padding: 10 }}>Qty</th>
          <th style={{ padding: 10 }}>Price</th>
          <th style={{ padding: 10 }}>Total</th>
        </tr>
      </thead>
      <tbody>
        {data.items.map((i, idx) => (
          <tr key={idx} style={{ backgroundColor: idx % 2 ? "#f8f9ff" : "#fff" }}>
            <td style={{ padding: 10 }}>{i.item_name}</td>
            <td style={{ padding: 10, textAlign: "center" }}>{i.quantity}</td>
            <td style={{ padding: 10, textAlign: "center" }}>{data.currency}{i.unit_price}</td>
            <td style={{ padding: 10, textAlign: "center" }}>{data.currency}{i.price}</td>
          </tr>
        ))}
      </tbody>
    </table>
    <div style={{ textAlign: "right", fontSize: 10 }}>
      <div style={{ backgroundColor: "#f8f9ff", padding: 15, borderRadius: 8 }}>
        <div style={{ marginBottom: 5 }}>Subtotal: {data.currency}{calculateSubtotal(data.items)}</div>
        <div style={{ marginBottom: 5 }}>Tax: {data.currency}{calculateTax(data).toFixed(2)}</div>
        <div style={{ fontSize: 12, fontWeight: "bold", color: "#667eea", borderTop: "2px solid #667eea", paddingTop: 8, marginTop: 8 }}>
          Total: {data.currency}{calculateTotal(data).toFixed(2)}
        </div>
      </div>
    </div>
  </div>
);

// ========== Template 4: Corporate Elegant ========== //
const CorporateTemplate = ({ data }) => (
  <div style={{ fontSize: 11, padding: 25, backgroundColor: "#fff", fontFamily: "Georgia, serif", border: "3px double #8b4513" }}>
    <div style={{ textAlign: "center", marginBottom: 25, borderBottom: "2px solid #8b4513", paddingBottom: 20 }}>
      <img src={data.company.logo} alt="Logo" style={{ width: 100, height: 50, marginBottom: 10 }} />
      <h6 style={{ fontSize: 28, color: "#8b4513", margin: 0, fontWeight: "bold", letterSpacing: 2 }}>INVOICE</h6>
      <div style={{ fontSize: 9, color: "#666", marginTop: 5 }}>{data.company.name} • {data.company.email}</div>
    </div>
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 25 }}>
      <div style={{ fontSize: 10, backgroundColor: "#f5f5dc", padding: 15, borderLeft: "4px solid #8b4513", flex: 1, marginRight: 10 }}>
        <div style={{ fontWeight: "bold", color: "#8b4513", marginBottom: 8 }}>INVOICE TO:</div>
        <div style={{ fontWeight: "bold" }}>{data.customer_name}</div>
        <div>{data.address}</div>
        <div>{data.phone}</div>
      </div>
      <div style={{ fontSize: 10, backgroundColor: "#f5f5dc", padding: 15, borderRight: "4px solid #8b4513", textAlign: "right", flex: 1 }}>
        <div style={{ fontWeight: "bold", color: "#8b4513" }}>Invoice Details</div>
        <div>Number: {data.invoice_number}</div>
        <div>Date: {convertDateFormat(data.issue_date)}</div>
        <div>Order: {data.order_number}</div>
      </div>
    </div>
    <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 25, border: "2px solid #8b4513" }}>
      <thead>
        <tr style={{ backgroundColor: "#8b4513", color: "#fff" }}>
          <th style={{ padding: 12, textAlign: "left", borderRight: "1px solid #fff" }}>Service Description</th>
          <th style={{ padding: 12, borderRight: "1px solid #fff" }}>Quantity</th>
          <th style={{ padding: 12, borderRight: "1px solid #fff" }}>Unit Price</th>
          <th style={{ padding: 12 }}>Line Total</th>
        </tr>
      </thead>
      <tbody>
        {data.items.map((i, idx) => (
          <tr key={idx} style={{ backgroundColor: idx % 2 ? "#fafafa" : "#fff" }}>
            <td style={{ padding: 10, borderBottom: "1px solid #ddd", borderRight: "1px solid #ddd" }}>
              <div style={{ fontWeight: "bold" }}>{i.item_name}</div>
              <div style={{ fontSize: 9, color: "#666" }}>{i.description}</div>
            </td>
            <td style={{ padding: 10, textAlign: "center", borderBottom: "1px solid #ddd", borderRight: "1px solid #ddd" }}>{i.quantity}</td>
            <td style={{ padding: 10, textAlign: "right", borderBottom: "1px solid #ddd", borderRight: "1px solid #ddd" }}>{data.currency}{i.unit_price}</td>
            <td style={{ padding: 10, textAlign: "right", borderBottom: "1px solid #ddd" }}>{data.currency}{i.price}</td>
          </tr>
        ))}
      </tbody>
    </table>
    <div style={{ textAlign: "right", fontSize: 11 }}>
      <div style={{ backgroundColor: "#f5f5dc", padding: 15, border: "1px solid #8b4513", display: "inline-block", minWidth: 200 }}>
        <div style={{ marginBottom: 8 }}>Subtotal: {data.currency}{calculateSubtotal(data.items)}</div>
        <div style={{ marginBottom: 8 }}>Tax Rate: {data.tax}%</div>
        <div style={{ marginBottom: 8 }}>Tax Amount: {data.currency}{calculateTax(data).toFixed(2)}</div>
        <div style={{ borderTop: "2px solid #8b4513", paddingTop: 8, fontWeight: "bold", fontSize: 14, color: "#8b4513" }}>
          TOTAL DUE: {data.currency}{calculateTotal(data).toFixed(2)}
        </div>
      </div>
    </div>
  </div>
);

// ========== Template 5: Tech Futuristic ========== //
const TechTemplate = ({ data }) => (
  <div style={{ fontSize: 11, padding: 20, backgroundColor: "#0f1419", color: "#fff", fontFamily: "Courier, monospace", border: "2px solid #00d4ff" }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, borderBottom: "1px solid #00d4ff", paddingBottom: 15 }}>
      <div>
        <img src={data.company.logo} alt="Logo" style={{ width: 80, height: 40, filter: "invert(1)" }} />
        <div style={{ color: "#00d4ff", fontSize: 18, fontWeight: "bold", marginTop: 5 }}>[ INVOICE ]</div>
      </div>
      <div style={{ textAlign: "right", fontSize: 9, fontFamily: "monospace" }}>
        <div style={{ color: "#00d4ff" }}>{data.company.name}</div>
        <div>{data.company.address}</div>
        <div>{data.company.email}</div>
      </div>
    </div>
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
      <div style={{ fontSize: 10, backgroundColor: "#1a2332", padding: 12, border: "1px solid #00d4ff" }}>
        <div style={{ color: "#00d4ff", fontWeight: "bold" }}>CLIENT_DATA:</div>
        <div>{data.customer_name}</div>
        <div>{data.address}</div>
        <div>{data.phone}</div>
      </div>
      <div style={{ fontSize: 10, backgroundColor: "#1a2332", padding: 12, border: "1px solid #00d4ff", textAlign: "right" }}>
        <div style={{ color: "#00d4ff", fontWeight: "bold" }}>INVOICE_META:</div>
        <div>ID: {data.invoice_number}</div>
        <div>DATE: {convertDateFormat(data.issue_date)}</div>
        <div>ORDER: {data.order_number}</div>
      </div>
    </div>
    <div style={{ fontSize: 10, color: "#00d4ff", marginBottom: 10 }}>// ITEMIZED BILLING DATA</div>
    <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 20, backgroundColor: "#1a2332", border: "1px solid #00d4ff" }}>
      <thead>
        <tr style={{ backgroundColor: "#00d4ff", color: "#0f1419" }}>
          <th style={{ padding: 8, textAlign: "left", fontFamily: "monospace" }}>ITEM.NAME</th>
          <th style={{ padding: 8, fontFamily: "monospace" }}>QTY</th>
          <th style={{ padding: 8, fontFamily: "monospace" }}>RATE</th>
          <th style={{ padding: 8, fontFamily: "monospace" }}>TOTAL</th>
        </tr>
      </thead>
      <tbody>
        {data.items.map((i, idx) => (
          <tr key={idx} style={{ borderBottom: "1px solid #2a3441" }}>
            <td style={{ padding: 8 }}>{i.item_name}</td>
            <td style={{ padding: 8, textAlign: "center" }}>{i.quantity}</td>
            <td style={{ padding: 8, textAlign: "center" }}>{data.currency}{i.unit_price}</td>
            <td style={{ padding: 8, textAlign: "center" }}>{data.currency}{i.price}</td>
          </tr>
        ))}
      </tbody>
    </table>
    <div style={{ textAlign: "right", fontSize: 10, fontFamily: "monospace" }}>
      <div style={{ backgroundColor: "#1a2332", padding: 12, border: "1px solid #00d4ff", display: "inline-block" }}>
        <div>SUBTOTAL: {data.currency}{calculateSubtotal(data.items)}</div>
        <div>TAX_RATE: {data.tax}%</div>
        <div>TAX_AMT: {data.currency}{calculateTax(data).toFixed(2)}</div>
        <div style={{ color: "#00d4ff", fontWeight: "bold", borderTop: "1px solid #00d4ff", paddingTop: 8, marginTop: 8 }}>
          TOTAL_DUE: {data.currency}{calculateTotal(data).toFixed(2)}
        </div>
      </div>
    </div>
  </div>
);

// ========== Template 6: Artistic Handwritten ========== //
const ArtisticTemplate = ({ data }) => (
  <div style={{ fontSize: 12, padding: 25, backgroundColor: "#fffef7", fontFamily: "Comic Sans MS, cursive", border: "3px solid #d4af37", borderRadius: 15, position: "relative" }}>
    <div style={{ position: "absolute", top: -2, right: -2, width: 30, height: 30, backgroundColor: "#d4af37", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: "bold", fontSize: 14 }}>✓</div>
    <div style={{ textAlign: "center", marginBottom: 25 }}>
      <img src={data.company.logo} alt="Logo" style={{ width: 90, height: 45, marginBottom: 10 }} />
      <h6 style={{ fontSize: 24, color: "#8B4513", margin: 0, textShadow: "2px 2px 4px rgba(139,69,19,0.3)", transform: "rotate(-2deg)" }}>Invoice</h6>
      <div style={{ fontSize: 10, color: "#8B4513", transform: "rotate(1deg)" }}>~ {data.company.name} ~</div>
    </div>
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 25 }}>
      <div style={{ backgroundColor: "#fff", padding: 15, borderRadius: 10, boxShadow: "3px 3px 10px rgba(0,0,0,0.1)", transform: "rotate(-1deg)", fontSize: 11 }}>
        <div style={{ fontWeight: "bold", color: "#8B4513", marginBottom: 8 }}>For:</div>
        <div>{data.customer_name}</div>
        <div>{data.address}</div>
        <div>{data.phone}</div>
      </div>
      <div style={{ backgroundColor: "#fff", padding: 15, borderRadius: 10, boxShadow: "3px 3px 10px rgba(0,0,0,0.1)", transform: "rotate(1deg)", textAlign: "right", fontSize: 11 }}>
        <div style={{ fontWeight: "bold", color: "#8B4513" }}>Invoice Details</div>
        <div>#{data.invoice_number}</div>
        <div>{convertDateFormat(data.issue_date)}</div>
      </div>
    </div>
    <div style={{ backgroundColor: "#fff", padding: 20, borderRadius: 15, boxShadow: "5px 5px 15px rgba(0,0,0,0.1)", marginBottom: 20 }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ padding: 10, textAlign: "left", color: "#8B4513", borderBottom: "2px dashed #d4af37" }}>Item</th>
            <th style={{ padding: 10, color: "#8B4513", borderBottom: "2px dashed #d4af37" }}>Qty</th>
            <th style={{ padding: 10, color: "#8B4513", borderBottom: "2px dashed #d4af37" }}>Rate</th>
            <th style={{ padding: 10, color: "#8B4513", borderBottom: "2px dashed #d4af37" }}>Amount</th>
          </tr>
        </thead>
        <tbody>
          {data.items.map((i, idx) => (
            <tr key={idx}>
              <td style={{ padding: 10, borderBottom: "1px dotted #ddd" }}>{i.item_name}</td>
              <td style={{ padding: 10, textAlign: "center", borderBottom: "1px dotted #ddd" }}>{i.quantity}</td>
              <td style={{ padding: 10, textAlign: "center", borderBottom: "1px dotted #ddd" }}>{data.currency}{i.unit_price}</td>
              <td style={{ padding: 10, textAlign: "center", borderBottom: "1px dotted #ddd" }}>{data.currency}{i.price}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div style={{ textAlign: "right", fontSize: 11 }}>
      <div style={{ backgroundColor: "#d4af37", color: "#fff", padding: 15, borderRadius: 10, display: "inline-block", transform: "rotate(-1deg)" }}>
        <div style={{ marginBottom: 5 }}>Subtotal: {data.currency}{calculateSubtotal(data.items)}</div>
        <div style={{ marginBottom: 5 }}>Tax: {data.currency}{calculateTax(data).toFixed(2)}</div>
        <div style={{ fontWeight: "bold", fontSize: 14, borderTop: "2px solid #fff", paddingTop: 8, marginTop: 8 }}>
          Total: {data.currency}{calculateTotal(data).toFixed(2)}
        </div>
      </div>
    </div>
  </div>
);

// ========== Template 7: Bold Geometric ========== //
const GeometricTemplate = ({ data }) => (
  <div style={{ fontSize: 11, padding: 0, backgroundColor: "#fff", fontFamily: "Helvetica, sans-serif", overflow: "hidden" }}>
    <div style={{ backgroundColor: "#ff4757", padding: 20, color: "#fff", clipPath: "polygon(0 0, 100% 0, 85% 100%, 0% 100%)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <img src={data.company.logo} alt="Logo" style={{ width: 80, height: 40, filter: "brightness(0) invert(1)" }} />
          <h6 style={{ fontSize: 20, margin: "10px 0 0 0", fontWeight: "bold" }}>INVOICE</h6>
        </div>
        <div style={{ textAlign: "right", fontSize: 9 }}>
          <div>{data.company.name}</div>
          <div>{data.company.address}</div>
          <div>{data.company.email}</div>
        </div>
      </div>
    </div>
    <div style={{ padding: 20 }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 25 }}>
        <div style={{ fontSize: 10 }}>
          <div style={{ backgroundColor: "#2f3542", color: "#fff", padding: 8, marginBottom: 8, fontWeight: "bold" }}>BILL TO</div>
          <div>{data.customer_name}</div>
          <div>{data.address}</div>
          <div>{data.phone}</div>
        </div>
        <div style={{ fontSize: 10, textAlign: "right" }}>
          <div style={{ backgroundColor: "#ff6348", color: "#fff", padding: 8, marginBottom: 8, fontWeight: "bold" }}>DETAILS</div>
          <div>Invoice: {data.invoice_number}</div>
          <div>Date: {convertDateFormat(data.issue_date)}</div>
          <div>Order: {data.order_number}</div>
        </div>
      </div>
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 20 }}>
        <thead>
          <tr>
            <th style={{ padding: 12, textAlign: "left", backgroundColor: "#2f3542", color: "#fff", clipPath: "polygon(0 0, 95% 0, 100% 100%, 0% 100%)" }}>Description</th>
            <th style={{ padding: 12, backgroundColor: "#ff6348", color: "#fff" }}>Qty</th>
            <th style={{ padding: 12, backgroundColor: "#ff6348", color: "#fff" }}>Price</th>
            <th style={{ padding: 12, backgroundColor: "#2f3542", color: "#fff", clipPath: "polygon(0 0, 100% 0, 100% 100%, 5% 100%)" }}>Total</th>
          </tr>
        </thead>
        <tbody>
          {data.items.map((i, idx) => (
            <tr key={idx} style={{ backgroundColor: idx % 2 ? "#f8f9fa" : "#fff" }}>
              <td style={{ padding: 10, borderBottom: "1px solid #ddd" }}>{i.item_name}</td>
              <td style={{ padding: 10, textAlign: "center", borderBottom: "1px solid #ddd" }}>{i.quantity}</td>
              <td style={{ padding: 10, textAlign: "center", borderBottom: "1px solid #ddd" }}>{data.currency}{i.unit_price}</td>
              <td style={{ padding: 10, textAlign: "right", borderBottom: "1px solid #ddd" }}>{data.currency}{i.price}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ textAlign: "right", fontSize: 10 }}>
        <div style={{ backgroundColor: "#f8f9fa", padding: 15, display: "inline-block", clipPath: "polygon(10% 0, 100% 0, 100% 100%, 0% 100%)" }}>
          <div style={{ marginBottom: 5 }}>Subtotal: {data.currency}{calculateSubtotal(data.items)}</div>
          <div style={{ marginBottom: 5 }}>Tax: {data.currency}{calculateTax(data).toFixed(2)}</div>
          <div style={{ fontWeight: "bold", color: "#ff4757", fontSize: 12 }}>Total: {data.currency}{calculateTotal(data).toFixed(2)}</div>
        </div>
      </div>
    </div>
  </div>
);

// ========== Template 8: Luxury Premium ========== //
const LuxuryTemplate = ({ data }) => (
  <div style={{ fontSize: 11, padding: 30, backgroundColor: "#1a1a1a", color: "#d4af37", fontFamily: "Times New Roman, serif", border: "4px solid #d4af37", position: "relative" }}>
    <div style={{ position: "absolute", top: 10, left: 10, width: 20, height: 20, border: "2px solid #d4af37", transform: "rotate(45deg)" }}></div>
    <div style={{ position: "absolute", top: 10, right: 10, width: 20, height: 20, border: "2px solid #d4af37", transform: "rotate(45deg)" }}></div>
    <div style={{ position: "absolute", bottom: 10, left: 10, width: 20, height: 20, border: "2px solid #d4af37", transform: "rotate(45deg)" }}></div>
    <div style={{ position: "absolute", bottom: 10, right: 10, width: 20, height: 20, border: "2px solid #d4af37", transform: "rotate(45deg)" }}></div>
    
    <div style={{ textAlign: "center", marginBottom: 30, borderBottom: "3px double #d4af37", paddingBottom: 20 }}>
      <img src={data.company.logo} alt="Logo" style={{ width: 100, height: 50, marginBottom: 15, filter: "sepia(1) hue-rotate(35deg)" }} />
      <h6 style={{ fontSize: 32, color: "#d4af37", margin: 0, fontWeight: "bold", letterSpacing: 3, textShadow: "2px 2px 4px rgba(212,175,55,0.3)" }}>INVOICE</h6>
      <div style={{ fontSize: 10, color: "#ccc", marginTop: 5, letterSpacing: 1 }}>PREMIUM SERVICES</div>
    </div>
    
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 30 }}>
      <div style={{ fontSize: 10, backgroundColor: "#2a2a2a", padding: 20, border: "2px solid #d4af37", flex: 1, marginRight: 15 }}>
        <div style={{ color: "#d4af37", fontWeight: "bold", marginBottom: 10, fontSize: 12 }}>DISTINGUISHED CLIENT</div>
        <div style={{ color: "#fff", fontWeight: "bold" }}>{data.customer_name}</div>
        <div style={{ color: "#ccc" }}>{data.address}</div>
        <div style={{ color: "#ccc" }}>{data.phone}</div>
      </div>
      <div style={{ fontSize: 10, backgroundColor: "#2a2a2a", padding: 20, border: "2px solid #d4af37", textAlign: "right" }}>
        <div style={{ color: "#d4af37", fontWeight: "bold", marginBottom: 10, fontSize: 12 }}>INVOICE PARTICULARS</div>
        <div style={{ color: "#fff" }}>Invoice Number: {data.invoice_number}</div>
        <div style={{ color: "#ccc" }}>Issue Date: {convertDateFormat(data.issue_date)}</div>
        <div style={{ color: "#ccc" }}>Order Reference: {data.order_number}</div>
      </div>
    </div>
    
    <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 30, backgroundColor: "#2a2a2a", border: "2px solid #d4af37" }}>
      <thead>
        <tr style={{ backgroundColor: "#d4af37", color: "#1a1a1a" }}>
          <th style={{ padding: 15, textAlign: "left", fontWeight: "bold", fontSize: 11 }}>SERVICE DESCRIPTION</th>
          <th style={{ padding: 15, fontWeight: "bold", fontSize: 11 }}>QUANTITY</th>
          <th style={{ padding: 15, fontWeight: "bold", fontSize: 11 }}>UNIT RATE</th>
          <th style={{ padding: 15, fontWeight: "bold", fontSize: 11 }}>LINE TOTAL</th>
        </tr>
      </thead>
      <tbody>
        {data.items.map((i, idx) => (
          <tr key={idx} style={{ borderBottom: "1px solid #444" }}>
            <td style={{ padding: 12, color: "#fff" }}>
              <div style={{ fontWeight: "bold" }}>{i.item_name}</div>
              <div style={{ fontSize: 9, color: "#ccc", marginTop: 2 }}>{i.description}</div>
            </td>
            <td style={{ padding: 12, textAlign: "center", color: "#d4af37" }}>{i.quantity}</td>
            <td style={{ padding: 12, textAlign: "center", color: "#d4af37" }}>{data.currency}{i.unit_price}</td>
            <td style={{ padding: 12, textAlign: "center", color: "#fff", fontWeight: "bold" }}>{data.currency}{i.price}</td>
          </tr>
        ))}
      </tbody>
    </table>
    
    <div style={{ textAlign: "right", fontSize: 11 }}>
      <div style={{ backgroundColor: "#2a2a2a", border: "2px solid #d4af37", padding: 20, display: "inline-block", minWidth: 250 }}>
        <div style={{ marginBottom: 10, color: "#ccc" }}>Subtotal: <span style={{ color: "#fff" }}>{data.currency}{calculateSubtotal(data.items)}</span></div>
        <div style={{ marginBottom: 10, color: "#ccc" }}>Discount ({data.discount}%): <span style={{ color: "#fff" }}>-{data.currency}{((calculateSubtotal(data.items) * data.discount) / 100).toFixed(2)}</span></div>
        <div style={{ marginBottom: 15, color: "#ccc" }}>Tax ({data.tax}%): <span style={{ color: "#fff" }}>{data.currency}{calculateTax(data).toFixed(2)}</span></div>
        <div style={{ borderTop: "3px double #d4af37", paddingTop: 15, fontSize: 16, fontWeight: "bold", color: "#d4af37", textAlign: "center", letterSpacing: 1 }}>
          TOTAL AMOUNT DUE<br/>
          <span style={{ fontSize: 20 }}>{data.currency}{calculateTotal(data).toFixed(2)}</span>
        </div>
      </div>
    </div>
  </div>
);

// ================== Page ================== //
export default function TemplateSelectionPage() {
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedTemplateName, setSelectedTemplateName] = useState(null);
  const [showTemplateAlert,setShowTemplateAlert]= useState(false)
  const [previewTemplate, setPreviewTemplate] = useState(null);
  const fetchByLocation = async()=>{
    try {
        const res = await fetch(API_URL+"/api/templates/active/"+LOCATION_ID, {
          method: "GET",
        });
        if(res.status === 404) throw new Error("Select the template");
        if (!res.ok) throw new Error("Failed to save template");
        const response = await res.json();
        
        setSelectedTemplate(response.templateId);
        setSelectedTemplateName(response.templateName)
        setShowTemplateAlert(false)
      } catch (err) {
        if(err.message == "Select the template"){
            setShowTemplateAlert(true)
        }
        
        console.log(err.message)
      }
  }
useEffect(() => {
    fetchByLocation();
}, [])

  const handleSubmit = async () => {
    if (!selectedTemplate) return alert("Please select a template!");
    try {
      const res = await fetch(API_URL+ "/api/templates/select", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ templateId: selectedTemplate, location_id: LOCATION_ID,templateName: selectedTemplateName }),
      });
      if (!res.ok) throw new Error("Failed to save template");
      
      toast.success('Template saved successfully!', {
        position: 'top-right',
        autoClose: 3000,
      });
      fetchByLocation();
    } catch (err) {
      alert("Error: " + err.message);
    }
  };

  const templates = [
    { id: 1, name: "Classic Professional", component: <ClassicTemplate data={sampleData} />, description: "Traditional corporate design with clean lines" },
    { id: 2, name: "Modern Minimal", component: <ModernTemplate data={sampleData} />, description: "Clean, contemporary layout with subtle colors" },
    { id: 3, name: "Creative Colorful", component: <CreativeTemplate data={sampleData} />, description: "Vibrant gradient design with creative flair" },
    { id: 4, name: "Corporate Elegant", component: <CorporateTemplate data={sampleData} />, description: "Sophisticated serif typography with formal structure" },
    
  ];

  return (
    <MasterLayout>
      <div style={{ 
        padding: 30, 
        backgroundColor: "#f8f9fa", 
        minHeight: "100vh",
        
      }}>
        <div style={{ 
          maxWidth: 1400, 
          margin: "0 auto",
          backgroundColor: "#fff",
          borderRadius: 20,
          padding: 30,
          boxShadow: "0 20px 60px rgba(0,0,0,0.1)"
        }}>
            {
                showTemplateAlert && (
                    <div className="alert alert-warning" >
                <div className="row">
                    <div className="col-md-6">
                    <span>Please select the template, default template is linked to this location</span>
                    </div>
                    <div className="col-md-6 text-end">
                  
                    </div>
                </div>
            </div>
                )
            }
          <div style={{ textAlign: "center", marginBottom: 40 }}>
            <h5 style={{ 
              fontSize: 25, 
              color: "#333", 
              marginBottom: 10,
              fontWeight: "bold",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "black"
            }}>
              Choose Your Invoice Template
            </h5>
            <p style={{ 
              fontSize: 16, 
              color: "#666", 
              maxWidth: 600, 
              margin: "0 auto",
              lineHeight: 1.6 
            }}>
              Select from our professionally designed invoice templates. Each template is crafted to make your business look professional and trustworthy.
            </p>
          </div>

          <div style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(auto-fit, minmax(380px, 1fr))", 
            gap: 25,
            marginBottom: 40
          }}>
            {templates.map((tpl) => (
              <div
                key={tpl.id}
                style={{
                  border: selectedTemplate === tpl.id ? "3px solid #667eea" : "2px solid #e9ecef",
                  borderRadius: 15,
                  overflow: "hidden",
                  backgroundColor: "#fff",
                  boxShadow: selectedTemplate === tpl.id 
                    ? "0 15px 40px rgba(102, 126, 234, 0.3)" 
                    : "0 8px 25px rgba(0,0,0,0.1)",
                  transition: "all 0.3s ease",
                  transform: selectedTemplate === tpl.id ? "translateY(-5px)" : "translateY(0)",
                  position: "relative",
                  cursor: "pointer"
                }}
                onMouseEnter={(e) => {
                  if (selectedTemplate !== tpl.id) {
                    e.target.style.boxShadow = "0 12px 35px rgba(0,0,0,0.15)";
                    e.target.style.transform = "translateY(-3px)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedTemplate !== tpl.id) {
                    e.target.style.boxShadow = "0 8px 25px rgba(0,0,0,0.1)";
                    e.target.style.transform = "translateY(0)";
                  }
                }}
              >
                {/* Template Preview */}
                <div style={{ 
                  height: 280, 
                  overflow: "hidden",
                  position: "relative"
                }}>
                  <div style={{ transform: "scale(0.7)", transformOrigin: "top left", width: "142.8%" }}>
                    {tpl.component}
                  </div>
                  {selectedTemplate === tpl.id && (
                    <div style={{
                      position: "absolute",
                      top: 15,
                      right: 15,
                      backgroundColor: "#28a745",
                      color: "#fff",
                      width: 35,
                      height: 35,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 18,
                      fontWeight: "bold",
                      boxShadow: "0 4px 12px rgba(40, 167, 69, 0.4)"
                    }}>✓</div>
                  )}
                </div>

                {/* Template Info */}
                <div style={{ padding: 20 }}>
                  <h6 style={{ 
                    fontSize: 18, 
                    fontWeight: "bold", 
                    color: "#333", 
                    marginBottom: 8,
                    marginTop: 0
                  }}>
                    {tpl.name}
                  </h6>
                  <p style={{ 
                    fontSize: 14, 
                    color: "#666", 
                    marginBottom: 15,
                    lineHeight: 1.4,
                    margin: "0 0 15px 0"
                  }}>
                    {tpl.description}
                  </p>

                  {/* Action Buttons */}
                  <div style={{ display: "flex", gap: 10 }}>
                    <button
                      onClick={() => {
                        setSelectedTemplate(tpl.id)
                        setSelectedTemplateName(tpl.name)
                    }}
                      style={{
                        flex: 1,
                        padding: "10px 15px",
                        background: selectedTemplate === tpl.id 
                          ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" 
                          : "#f8f9fa",
                        color: selectedTemplate === tpl.id ? "#fff" : "#333",
                        border: selectedTemplate === tpl.id ? "none" : "2px solid #e9ecef",
                        borderRadius: 8,
                        cursor: "pointer",
                        fontWeight: "600",
                        fontSize: 14,
                        transition: "all 0.2s ease"
                      }}
                      onMouseEnter={(e) => {
                        if (selectedTemplate !== tpl.id) {
                          e.target.style.backgroundColor = "#e9ecef";
                          e.target.style.borderColor = "#dee2e6";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (selectedTemplate !== tpl.id) {
                          e.target.style.backgroundColor = "#f8f9fa";
                          e.target.style.borderColor = "#e9ecef";
                        }
                      }}
                    >
                      {selectedTemplate === tpl.id ? "✓ Selected" : "Select"}
                    </button>
                    <button
                      onClick={() => setPreviewTemplate(tpl)}
                      style={{
                        padding: "10px 20px",
                        background: "transparent",
                        color: "#667eea",
                        border: "2px solid #667eea",
                        borderRadius: 8,
                        cursor: "pointer",
                        fontWeight: "600",
                        fontSize: 14,
                        transition: "all 0.2s ease"
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#667eea";
                        e.target.style.color = "#fff";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "transparent";
                        e.target.style.color = "#667eea";
                      }}
                    >
                      Preview
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Save Button */}
          <div style={{ textAlign: "center" }}>
            <button
              onClick={handleSubmit}
              disabled={!selectedTemplate}
              style={{
                padding: "15px 40px",
                background: selectedTemplate 
                  ? "linear-gradient(135deg, #28a745 0%, #20c997 100%)" 
                  : "#e9ecef",
                color: selectedTemplate ? "#fff" : "#6c757d",
                border: "none",
                borderRadius: 50,
                cursor: selectedTemplate ? "pointer" : "not-allowed",
                fontWeight: "bold",
                fontSize: 16,
                boxShadow: selectedTemplate 
                  ? "0 8px 25px rgba(40, 167, 69, 0.3)" 
                  : "none",
                transition: "all 0.3s ease",
                transform: selectedTemplate ? "translateY(0)" : "translateY(0)"
              }}
              onMouseEnter={(e) => {
                if (selectedTemplate) {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow = "0 12px 35px rgba(40, 167, 69, 0.4)";
                }
              }}
              onMouseLeave={(e) => {
                if (selectedTemplate) {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "0 8px 25px rgba(40, 167, 69, 0.3)";
                }
              }}
            >
              {selectedTemplate ? "Save Selected Template" : "Please Select a Template"}
            </button>
          </div>
        </div>
      </div>

      {/* Preview Modal */}
      {previewTemplate && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            backdropFilter: "blur(5px)"
          }}
          onClick={() => setPreviewTemplate(null)}
        >
          <div 
            style={{
              backgroundColor: "#fff",
              borderRadius: 15,
              width: "90%",
              maxWidth: 800,
              maxHeight: "90%",
              overflowY: "auto",
              boxShadow: "0 25px 80px rgba(0,0,0,0.3)",
              position: "relative"
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div style={{
              padding: "20px 30px",
              borderBottom: "2px solid #f8f9fa",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#f8f9fa",
              borderRadius: "15px 15px 0 0"
            }}>
              <div>
                <h5 style={{ margin: 0, color: "#333", fontSize: 24 }}>{previewTemplate.name}</h5>
                <p style={{ margin: "5px 0 0 0", color: "#666", fontSize: 14 }}>{previewTemplate.description}</p>
              </div>
              <button
                onClick={() => setPreviewTemplate(null)}
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  border: "none",
                  backgroundColor: "#dc3545",
                  color: "#fff",
                  fontSize: 18,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.2s ease"
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#c82333";
                  e.target.style.transform = "scale(1.1)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#dc3545";
                  e.target.style.transform = "scale(1)";
                }}
              >
                ×
              </button>
            </div>

            {/* Modal Content */}
            <div style={{ padding: 30 }}>
              {previewTemplate.component}
            </div>

            {/* Modal Footer */}
            <div style={{
              padding: "20px 30px",
              borderTop: "2px solid #f8f9fa",
              backgroundColor: "#f8f9fa",
              borderRadius: "0 0 15px 15px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}>
              <button
                onClick={() => {
                  setSelectedTemplate(previewTemplate.id);
                  setPreviewTemplate(null);
                }}
                style={{
                  padding: "10px 25px",
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  cursor: "pointer",
                  fontWeight: "600",
                  fontSize: 14,
                  transition: "all 0.2s ease"
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-1px)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                }}
              >
                Select This Template
              </button>
              <button
                onClick={() => setPreviewTemplate(null)}
                style={{
                  padding: "10px 25px",
                  backgroundColor: "#6c757d",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  cursor: "pointer",
                  fontWeight: "600",
                  fontSize: 14,
                  transition: "all 0.2s ease"
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#5a6268";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#6c757d";
                }}
              >
                Close Preview
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer/>
    </MasterLayout>
  );
}